import React from "react"

import Layout2 from "../components/layout2"
import SEO from "../components/seo"
import { Breadcrumb } from "../components/globals/breadcrumb";
import InternLinks from "../components/internlinks";
import { FaCheck } from 'react-icons/fa';

const IndexPage = () => (
  <Layout2>
        <Breadcrumb category={["recensioner", "recensioner"]} page={["beconfident", "beconfident"]}/>
     <SEO title="Beconfident" description="Recension av Beconfident" keywords={[`Beconfident`, `Vita tänder`, `Vitare tänder`, `Tandblekning hemma`, `Bleka tänder`]}/>
     <section className="section-produkter">
       <article>
       <div className="prod-text">
          <h1>Vita tänder med Beconfident</h1>
         </div>
      </article>
      <article class="right">
        <img src="../tandblekning-be.jpg" alt="Beconfident tandblekning"/>
        <aside>
          <h3  style={{color:"black"}}>795:-</h3>
          <h2>Tandblekning Premium X3 Kit</h2>
          <p class="prod-beskrivning">Deras bästa Start Kit som består av <b>två</b> olika <b>tandbleknings geler</b>.
            Paketet innehåller även <b>Tooth gloss</b> (värde 189:-), som skyddar emaljen från missfärgningar
            och den går även att borsta tänderna med.
          </p>
          <a href="https://click.adrecord.com?c=36553&p=1028&url=https%3A//beconfident.com/sv/produkt/tandblekning-x3-premium-kit/" target="_blank" rel="noopener noreferrer" class="btn btn-warning btn-width">Beställ här</a>
          <ul>
             <li><FaCheck className="li-icon" /> 1-2 nyanser på bara 30 minuter</li>
             <li><FaCheck className="li-icon" /> Fräsch mintsmak</li>
             <li><FaCheck className="li-icon" /> Ingen risk för smärta, ilningar</li>
          </ul>
        </aside>
        <div className="prod-text"><h5>Om tandblekning hemma med Premium X3 Kit</h5>
         <p>Dual-Boost är en unik och patenterad teknologi. Den fungerar i två olika steg för att ta fram vita tänder. 
          Detta betyder att tänderna bleks med två olika metoder. Redan efter 30 minuter kan man se snabbt få lite vitare tänder.</p>
          <p>Premiumkitet är mer effektivare än deras start kit och ger ett snabbare och vitare resultat. 
            Tandglossen (värde 189:-), medföljer och skyddar dina vita tänder. </p></div>
      </article>
      <article>
        <img src="../strips-be.jpg" alt="beconfident tandblekningspenna"/> 
        <aside>
          <h3>295:-</h3>
          <h2>Tandblekning Strips</h2>
          <p class="prod-beskrivning">Enkla, snabba och effektiva att använda. Ljusa vita tänder för ett vackert och attraktivt leende efter <b>bara 15 minuter</b>.</p>
          <a href="https://click.adrecord.com?c=36553&p=1028&url=https%3A//beconfident.com/sv/produkt/teeth-whitening-strips-10-days/" target="_blank" rel="noopener noreferrer" class="btn btn-warning btn-width">Beställ här</a>
        <ul>
            <li><FaCheck className="li-icon" /> 3 nyanser vitare på 5 dagar</li>
            <li><FaCheck className="li-icon" /> Kliniskt testad</li>
            <li><FaCheck className="li-icon" /> Lätta att ta med sig på resor</li>
          </ul>
        </aside>
        <div className="prod-text"><h5>Beconfident stripes</h5>
        <p>Har utvecklats i samarbete med en av de mest kända tandläkarna inom tandblekning. Fördelen med strips är att ingen formning av munskenor behövs
          utan det är bara att börja direkt. De är extra tunna och formade för att passa perfekt på övre och nedre tänderna.</p>
          <p>Smidig tandblekning att använda varsomhelst.</p></div>
      </article>
      <article>
        <div className="prod-text"><h5>Om tandblekning hemma med Beconfident</h5>
        <p>Enkel och smidig hemsida att beställa produkterna på. Man har många olika betalningsmetoder, där vi gillar Klarna bäst. Man har över 500 000 kunder och väldigt 
          bra kundservice. Varorna levereras från dom innan kl 15.00 samma dag. De erbjuder 100% nöjd kund garanti, och fri frakt om du beställer över 500:-. De säljer även
          många andra produkter för dina vita tänder. Tandborstar, tandkräm, tandblekningspennor tex. </p>
          <a href="https://click.adrecord.com?c=36553&p=1028" target="_blank" rel="noopener noreferrer">Se alla deras produkter här</a>
        </div>
      </article>
       </section>
       {/* <section className="section-cards">
    <main>
    <h2 class="rubrik-tandblekning">Bästa tandblekningen hemma</h2>
       <Card />
       </main>
  </section> */}

  <section className="section-cards card-height">
  <main>
      <h2 class="internal-rubrik">Bästa tandblekningen hemma</h2>
    <InternLinks />
    </main>
  </section>
  </Layout2>
)

export default IndexPage
